<script setup>
import { useI18n } from 'vue-i18n';
import SpacingField from '../../fields/SpacingField.vue';
import VisibilityField from '../../fields/VisibilityField.vue';

defineProps({
  node: { type: Object, required: true },
  // Elemento do rodapé fica sempre visível (o servidor força): sem o campo.
  selection: { type: Object, default: null },
});
const emit = defineEmits(['update']);
const { t } = useI18n();
</script>

<template>
  <div data-props="html" class="flex flex-col gap-4">
    <label class="flex flex-col gap-1.5">
      <span class="text-xs font-medium text-n-slate-11">{{
        t('EMAIL_TEMPLATES.EDITOR.PROPS.HTML')
      }}</span>
      <textarea
        class="h-64 rounded-lg border border-n-weak bg-n-solid-1 p-2 font-mono text-xs"
        spellcheck="false"
        :value="node.html"
        @input="emit('update', { html: $event.target.value }, 'html')"
      />
    </label>
    <p class="text-[11px] text-n-slate-10">
      {{ t('EMAIL_TEMPLATES.EDITOR.PROPS.HTML_HINT') }}
    </p>
    <SpacingField
      :label="t('EMAIL_TEMPLATES.EDITOR.PROPS.PADDING')"
      :model-value="node.style?.padding"
      @update:model-value="
        v => emit('update', { style: { padding: v } }, 'padding')
      "
    />
    <VisibilityField
      v-if="selection?.row?.role !== 'footer'"
      :model-value="node.style?.hide_on"
      @update:model-value="
        v => emit('update', { style: { hide_on: v } }, 'hide_on')
      "
    />
  </div>
</template>
